module.exports = __webpack_public_path__ + "media/img/career_starter_de-083194d5ba721e631cf4cf058f734cb1.jpg";